/**
 * @see https://day.js.org/docs/en/display/format
 * @see https://momentjs.com
 */
export default {
    methods: {
        dayjs(value) {
            return window.dayjs(value)
                .local();
        },

        date(value) {
            /*return moment
                .utc(value)
                .local()
                .format("MMMM Do, YYYY");*/
        },

        dateShort(value) {
            return window.dayjs(value)
                .local()
                .format('MM/DD');

            /*return moment
                .utc(value)
                .local()
                .format("M/D");*/
        },

        dateTime(value) {
            return window.dayjs(value)
                .local()
                .format('MM-DD HH:MM');
                // .format('YYYY-MM-DD hh:mm a');

            /*return moment
                .utc(value)
                .local()
                .format("MMMM Do, YYYY h:mm A");*/
        },

        dateTime2(value) {
            return window.dayjs(value)
                .local()
                .format('MMM DD HH:MM');
                // .format('YYYY-MM-DD hh:mm a');

            /*return moment
                .utc(value)
                .local()
                .format("MMMM Do, YYYY h:mm A");*/
        },

        dateTime3(value) {
            return window.dayjs(value)
                .local()
                .format('MMM DD YYYY HH:MM');
                // .format('YYYY-MM-DD hh:mm a');

            /*return moment
                .utc(value)
                .local()
                .format("MMMM Do, YYYY h:mm A");*/
        },

        relative(value) {
            return window.dayjs(value)
                .fromNow();

            /*return moment
                .utc(value)
                .local()
                .locale("en-short")
                .fromNow();*/
        }
    }
};
